import { Flex, Link, Text } from '@chakra-ui/react';
import { ChevronRightIcon, QuestionIcon } from '@udacity/chakra-uds-icons';

export function HelpCta() {
  return (
    <Link
      _hover={{ bg: 'blue.100', textDecoration: 'none' }}
      alignItems='center'
      bg='blue.50'
      border='1px solid'
      borderColor='blue.100'
      borderRadius='4px'
      color='grey.900'
      display='flex'
      href='https://support.udacity.com/hc/en-us'
      justifyContent='space-between'
      px={5}
      py={4}
      textDecoration='none'
      width='100%'
      isExternal
    >
      <Flex alignItems='center' columnGap={3} flexWrap='wrap' rowGap={1}>
        <QuestionIcon boxSize='24px' color='blue.500' flexShrink={0} />
        <Text fontFamily='heading' fontSize='18px' fontWeight='600' letterSpacing='-0.01em'>
          Need help?
        </Text>
        <Text
          color='blue.500'
          fontFamily='heading'
          fontSize='18px'
          fontWeight='600'
          letterSpacing='-0.01em'
          textDecoration='underline'
        >
          Contact us
        </Text>
      </Flex>
      <ChevronRightIcon boxSize='18px' color='grey.900' flexShrink={0} />
    </Link>
  );
}
